// Note: this file is not currently (August 2023) in use, because guidelines are disabled for EAF via showGuidelines set to false in CommentsNewForm

const generalGuidelines = `
  <p>Commenting guidelines:</p>
  <ul>
    <li>Aim to explain, not persuade</li>
    <li>Try to be clear, on-topic, and kind</li>
    <li>Approach disagreements with curiosity</li>
  </ul>
`
// TODO: Put this back in when links work
// <li>See our <a href="https://forum.effectivealtruism.org/about">guide to the Forum</a> for more notes on commenting.</li>

export const frontpageGuidelinesEA = generalGuidelines

export const defaultGuidelinesEA = generalGuidelines
